import BaseCollection from 'common/models/base/collection';
import Snapshot from './snapshot';

export default BaseCollection.extend({
  idProperty: 'guid',
  createModel(props) {
    props.snapshots = this;
    props.notifier = this.notifier;
    props.signatureRequest = this.signatureRequest;
    return Snapshot.create(props);
  },
});
